<!--
 * @Description: description
 * @Author: chenguobiao
 * @Date: 2021-12-22 22:36:03
 * @LastEditTime: 2021-12-25 02:20:00
 * @LastEditors: chenguobiao
-->
<template>
  <div class="progress">
    <div class="progress__bar">
      <div class="progress__bar--current" :style="[`width:${percentage};`]"></div>
    </div>
    <div class="progress__percentage">{{percentage}}</div>
  </div>
</template>

<script>
export default {
  props: {
    molecular: {
      type: Number,
      require: true
    },
    denominator: {
      type: Number,
      require: true
    },
  },
  computed: {
    percentage() {
      return parseInt((this.molecular / this.denominator) * 100) + '%'
    }
  }
}
</script>

<style lang="scss">
  .progress {
    display: flex;
    align-items: center;
    &__bar {
      margin-right: val(6);
      position: relative;
      width: val(360);
      height: val(12);
      background: #602E0D;
      border-radius: val(7);
      overflow: hidden;
      &--current {
        position: absolute;
        height: val(10);
        background: #E69660;
        border-radius: val(7);
        left: 0;
        top: 50%;
        transform: translateY(-50%);
      }
    }
    &__percentage {
      line-height: val(16);
      font-size: val(16);
      color: #FFDEB4;
    }

  }
</style>